export * from './src/avatar.module';
